import { caseService } from "../_services";

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,


  state: {
    categories: {
      list: [],
      status: status.INITIAL
    },
    selectedSort: 0,
    selectedFilter: 1
  },

  getters: {
    categories: ({ categories }) => categories.list.sort((a, b) => a.title.localeCompare(b.title)),
    isCategoriesLoaded: ({ categories }) => categories.status == status.LOADED,
  },
  mutations: {
    setCategories: ({ categories }, payload) => {
      categories.list = payload
    },

    setCategoriesStatus: ({ categories }, status) => {
      categories.status = status
    },

    selectSort: (state, payload) => {
      state.selectedSort = payload
    },

    selectFilter:(state, payload) => {
      state.selectedFilter = payload
    },
  },
  actions: {
    INIT: ({ dispatch }) => {
      dispatch('LOAD_CATEGORIES')
    },

    LOAD_CATEGORIES: ({ state, commit }) => {
      if (state.categories.status == status.INITIAL ) {
        commit('setCategoriesStatus', status.LOADING)

        caseService.listCategories().then(data => {
          commit('setCategories', data)
          commit('setCategoriesStatus', status.LOADED)
        })
      }
    },
  }
}